import DataGrid, { Column } from 'devextreme-react/data-grid';
import { bllSharedCellStyling } from '../../common/constants/tables/cells/styles/bllSharedCellStyling';
import { SBAColumns } from '../../common/constants/tables/columns/SBAColumns';
import { BorrowerLendingLimitTableType } from '../../common/constants/tables/BorrowerLendingLimitTableType';
import { currencyCellItemRender } from '../../common/constants/tables/cells/renders/currencyCellItemRender';
import { countCellRender } from '../../common/constants/tables/cells/renders/countCellRender';
import { summaryItemTypeCellRender } from '../../common/constants/tables/cells/renders/summaryItemCellRender';
import { ISBATableRow } from '../../common/constants/tables/interfaces/ISBATableRow';
import { ILoanHistorySummaryTableRow } from '../../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';

interface SBATableProps {
    sbaData?: ISBATableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const SBATable: React.FC<SBATableProps> = ({ onLoanSummaryClick, sbaData }) => {
    const prepareCells = (e) => {
        //Run shared styling
        bllSharedCellStyling(e);
    };

    return (
        <>
            <DataGrid
                dataSource={sbaData}
                keyExpr='summaryItemType'
                showBorders={false}
                showRowLines={false}
                rowAlternationEnabled={true}
                remoteOperations={false}
                allowColumnReordering={true}
                allowColumnResizing={true}
                noDataText='No SBA Information Available'
                onCellPrepared={(e) => {
                    prepareCells(e);
                }}
                style={{ padding: '10px' }}
            >
                <Column
                    dataField={SBAColumns.SummaryItemType}
                    caption=''
                    alignment={'left'}
                    width={160}
                    cellRender={(e) =>
                        summaryItemTypeCellRender(e, BorrowerLendingLimitTableType.SBA, SBAColumns.SummaryItemType)
                    }
                />
                <Column
                    dataField={SBAColumns.OutstandingAmount}
                    caption='Outstanding'
                    width={140}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.SBA)}
                />
                <Column
                    dataField={SBAColumns.OutstandingNumber}
                    caption=''
                    width={70}
                    alignment={'left'}
                    cellRender={(e) => countCellRender(e, () => onLoanSummaryClick(e.data.outstandingLoans))}
                />
                <Column
                    dataField={SBAColumns.BfiRepaysAmount}
                    caption='BFI Repays'
                    width={120}
                    alignment={'right'}
                    cellRender={(e) => currencyCellItemRender(e, BorrowerLendingLimitTableType.SBA)}
                />
                <Column
                    dataField={SBAColumns.BfiRepaysNumber}
                    caption=''
                    alignment={'left'}
                    cellRender={(e) => countCellRender(e, () => onLoanSummaryClick(e.data.bfiRepaysLoans))}
                />
            </DataGrid>
        </>
    );
};
